
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language files
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

// Resources
const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

// Add window typing for AdSense
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

i18n
  // Use language detector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // React already prevents XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;
